import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import { OptionContainer, Wrapper } from '../exercise/multiple-choice/styled';
import RadioOption from './radio-option';
import { HIGHLIGHT_TYPES } from '../../constants/exercise';
// import Stack from '../stack';

//Component prop is used for display for example index for SingleChoiche and not for TrueFalse
//gap is used for space between RadioOptions

export default class RadioGroup extends PureComponent {
    static propTypes = {
        Component: PropTypes.func,
        name: PropTypes.string,
        exerciseId: PropTypes.number,
        options: PropTypes.arrayOf(
            PropTypes.shape({
                id: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.bool]),
                text: PropTypes.string,
                selected: PropTypes.bool,
                disabled: PropTypes.bool,
                highlight: PropTypes.oneOf(HIGHLIGHT_TYPES),
            }),
        ),
        onClick: PropTypes.func,
        direction: PropTypes.oneOf(['vertical', 'horizontal']),
        gap: PropTypes.string,
    };

    static defaultProps = {
        gap: 'base',
        Component: () => ``,
        options: [{ selected: false }, { disabled: false }],
        direction: 'horizontal',
    };

    handleChange = (value) => {
        const { onClick } = this.props;
        if (onClick) {
            onClick(value);
        }
    };

    render() {
        const { exerciseId, options, name, direction, Component } = this.props;

        return (
            <Wrapper direction={direction}>
                {options.map((option, index) => {
                    return (
                        <OptionContainer key={index}>
                            <Component index={index} />
                            <RadioOption
                                id={exerciseId}
                                disabled={option.disabled}
                                checked={option.checked}
                                value={option.id}
                                key={option.id}
                                highlight={option.highlight}
                                selected={option.checked}
                                name={name}
                                onClick={this.handleChange}
                            >
                                {option.text}
                            </RadioOption>
                        </OptionContainer>
                    );
                })}
            </Wrapper>
        );
    }
}
